import { ComponentProps } from "react";
import { Tooltip } from "@timeedit/ui-components";

type TooltipDefaultProps = ComponentProps<typeof Tooltip>;

const TooltipDefault = ({ ...rest }: TooltipDefaultProps) => {
  return <Tooltip {...rest} />;
};

export default TooltipDefault;
